import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { EngineeringService } from 'src/app/services/engineering/engineering.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: 'app-mdlupload',
  templateUrl: './mdlupload.component.html',
  styleUrls: ['./mdlupload.component.css']
})
export class MdluploadComponent implements OnInit {

  data: any;
  files: File[];
  form: FormGroup;

  isSaveError : boolean = false;
  isSaveSuccess : boolean = false;
  isLoading : boolean = false;

  constructor(private engineeringServices: EngineeringService, private router: Router,
    private route: ActivatedRoute, private fb: FormBuilder) {

    this.form = this.fb.group({
      avatar: null
    });

  }

  ngOnInit() {
    this.getPurchaseOrderList();
  }

  getPurchaseOrderList() {
    this.engineeringServices.GetPurchaseOrderList().subscribe(
      data => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  onFileChange(event) {
    //alert("selected");
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      this.form.get('avatar').setValue(file);

      console.log(this.form.get('avatar').value);
    }
  }

  UploadExcelForm(form: NgForm) {
    this.isLoading = true;
    console.log(form.value);

    let input = new FormData();

    input.append('avatar', this.form.get('avatar').value);
    input.append('itemNo', form.value.itemNo);
    input.append('poNo', form.value.poNo);

    this.engineeringServices.uploadMdl(input).subscribe(
      (data: any) => {
        if(data == true)
        {
          this.isLoading = false;
          this.isSaveSuccess = true;
        }
        else
        {
          this.isLoading = false;
          this.isSaveError = true;
        }
      }
    );


  }


}
